"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSocket = exports.Pageview = exports.connectToWebsocket = void 0;
var io = require('socket.io-client');
var type_guard_1 = require("../type-guard");
var configuration_1 = require("./configuration");
/**
 * connect to websocket
 */
var connectionCounter = 0;
var connectToWebsocket = function (config, wsPath) { return __awaiter(void 0, void 0, void 0, function () {
    var query, serverUrl;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                connectionCounter++;
                if (connectionCounter > 1) {
                    console.warn("multiple connections", connectionCounter, wsPath, config);
                }
                query = {
                    api_key: config.apiKey
                };
                if ((0, type_guard_1.isServerConfigurationWithAdminSecret)(config)) {
                    query.admin_secret = config.adminSecret;
                }
                if ((0, type_guard_1.isServerConfigurationWithClientSecret)(config)) {
                    query.client_secret = config.clientSecret;
                }
                return [4 /*yield*/, (0, configuration_1.getServerUrl)(config)];
            case 1:
                serverUrl = _a.sent();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var socket = io(serverUrl, {
                            reconnectionAttempts: 10,
                            reconnectionDelay: 3 * 1000,
                            query: query,
                            path: "".concat(config.path).concat(wsPath),
                        });
                        socket.on("connect", resolve.bind(undefined, socket));
                        socket.on("connect_error", reject);
                    })];
        }
    });
}); };
exports.connectToWebsocket = connectToWebsocket;
/**
 * open websocket connection for pageview
 * @param {object} config
 * @param {object} entity
 * @param {object} event event_type property will be overwritten by server
 * @param {boolean} reply
 */
var Pageview = function (config, entity, event, reply) {
    if (event === void 0) { event = {}; }
    if (reply === void 0) { reply = false; }
    return new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
        var socket, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, exports.connectToWebsocket)(config, "send/socket.io")];
                case 1:
                    socket = _a.sent();
                    console.debug(socket.id);
                    socket.on("received/pageview", resolve);
                    socket.emit("send/pageview", { event: event, entity: entity, reply: reply });
                    resolve(true);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error(e_1);
                    resolve(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); });
};
exports.Pageview = Pageview;
/**
 * open websocket connection to get path
 * @param {object} config
 * @returns {Promise<SocketIOClient.Socket}
 */
var GetSocket = function (config) { return (0, exports.connectToWebsocket)(config, "get/socket.io"); };
exports.GetSocket = GetSocket;
